
import React, {Component} from 'react';
import Iframe from '../../components/iframe/iframe';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  width: 100%;

height:100%;
  justify-content: flex-start;
  align-items:stretch;
  align-self:center;



`;


    class SeaLevel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: 'https://resourcewatch.org/embed/data/explore?zoom=3&lat=0&lng=0.26367187500000006&basemap=dark&labels=light&layers=%255B%257B%2522dataset%2522%253A%2522e4946b37-ac8f-48f7-9498-dee5ab23db68%2522%252C%2522opacity%2522%253A1%252C%2522layer%2522%253A%252234f10622-4ff4-4412-a831-541e5566354b%2522%257D%255D&page=1&sort=most-viewed&sortDirection=-1'
        };
    }

    render() {
        return (
             <Center>
                <Iframe source={this.state.src} />
            </Center>
        );
    }
}

export default SeaLevel;